<template>
    <div v-if=true class="system-tabs">
        <div class="app-window" v-for="(window, index) in tabs" :key="index" :class="{'app-window--active': index === active}">
            <div v-if="!hideHeader" class="app-window__header" :class="`app-window__header-${window.name}`">
                <div class="app-window__title">
                    {{window.title}}
                </div>
                <div class="app-window__buttons">
                    <div class="app-window__button"></div>
                    <div class="app-window__button"></div>
                    <div class="app-window__button"></div>
                </div>
            </div>
            <div class="app-window__content" :class="`app-window__content-${window.modifier}`">
                <slot :name="window.slot"></slot>
            </div>
        </div>
        <div class="start-panel">
            <div v-if="$slots.help" class="start-panel__menu" @click="help = true"></div>
            <div class="start-panel__apps">
                <div
                        class="start-panel__app"
                        v-for="(app, index) in tabs"
                        :key="index"
                        @click="active = index"
                        v-if="app.title"
                        :class="[`start-panel__app--${app.name}`, {'start-panel__app--active': index === active}]"
                >
                    {{app.title}}
                </div>
            </div>
            <div class="start-panel__tray">
                <span class="start-panel__time">{{ formatDate.hour | FirstZero }}:{{ formatDate.minutes | FirstZero }}:{{ formatDate.seconds | FirstZero }}</span>
            </div>
        </div>

        <v-dialog v-model="help" scrollable max-width="900px">
            <v-card>
                <v-card-title>Помощь</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 100%;">
                    <slot name="help"></slot>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" flat @click.native="help = false">Закрыть</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import FirstZero from '@/filters/firstzero'

    export default {
        props: {
            hideHeader: Boolean,
            tabs: {
                type: Array,
                defaut: () => []
            }
        },
        data () {
            return {
                active: 0,
                help: false,
                localTime: new Date()
            }
        },
        created () {
            setInterval(() => {
                this.localTime = new Date()
            }, 1000)
        },
        computed: {
            formatDate () {
                return {
                    hour: this.localTime.getHours(),
                    minutes: this.localTime.getMinutes(),
                    seconds: this.localTime.getSeconds()
                }
            }
        },
        filters: {
            FirstZero
        }
    }
</script>

<style lang="stylus" scoped>

    .start-panel {
        height 50px
        box-shadow 0 -2px 5px rgba(0, 0, 0, 0.15)
        background-color #1c2429
        display flex
        flex-flow row nowrap
        justify-content flex-start
        align-items center
        position relative

        &__startmenu {
            overflow hidden
            opacity 0
            visibility hidden
            background rgba(0,0,0,0.7)
            position absolute
            bottom: 50px
            left 0
            color #fff
            height 100px
            padding-top 5px
            border-top 1px solid rgba(255,255,255,0.4)
            border-right 1px solid rgba(255,255,255,0.4)

            &--open {
                transition all 0.2s ease-in-out
                height 200px
                opacity 1
                visibility visible
            }

            &-item {
                position
                font-size 20px
                line-height 50px
                height 50px
                text-align left
                white-space nowrap
                padding 0 15px
                cursor pointer
                transition background  0.2s ease-out

                &:hover {
                    background #333
                }
            }
        }

        &__app,
        &__menu {
            position relative
            height 50px
            outline none
            min-width 50px
            text-align center
            transition background 0.2s ease-out, color .2s ease-out
            display flex
            flex-flow row nowrap
            justify-content flex-start
            align-items center

            &:hover {
                background #333
                color #fff
            }
        }

        &__menu::after {
            content ''
            display block
            width 100%
            height 100%
            background no-repeat center center / 25px auto url(../../../../public/images/question-icon.svg)
        }

        &__app {
            cursor default
            font-size 14px
            color rgba(255, 255, 255, .6)
            padding-right 12.5px

            &--active {
                &.start-panel__app::before {
                    filter grayscale(0%)
                }

                &::after {
                    content ''
                    display block
                    position absolute
                    bottom 0
                    left 5px
                    right 5px
                    height 2px
                    background rgba(255,255,255,0.5)
                    transition all 0.15s ease-out
                }

                &:hover {
                    &::after {
                        transition all 0.15s ease-out
                        left 0
                        right 0
                    }
                }
            }

            &::before {
                width 25px
                height 25px
                margin 0 12.5px
                content ''
                filter grayscale(100%)
                display inline-block
                vertical-align middle
                background no-repeat left center / contain
            }

            &--table {
                &::before {
                    width 22px
                    background-image url(../../../../public/images/spreadsheet-icon.svg)
                }
            }

            &--inventory {
                &::before {
                    background-image url(../../../../public/images/storage-icon.svg)
                }
            }

            &--browser {
                &::before {
                    background-image url(../../../../public/images/browser-icon.svg)
                }
            }

            &--email {
                &::before {
                    background-image url(../../../../public/images/email-icon.svg)
                }
            }

            &--doc {
                &::before {
                    width 20px
                    background-image url(../../../../public/images/doc-icon.svg)
                }
            }
        }

        &__apps {
            flex 1 0
            display flex
            flex-flow row nowrap
            justify-content flex-start
            align-items center
        }

        &__tray {
            color #fff
            padding 0 10px
            line-height 48px
        }

        &__time {
            cursor default
            padding 5px

            &:hover {
                background-color rgba(#fff, 0.1)
            }
        }
    }

    .app-window {
        display none
        overflow hidden
        height calc(100vh - 88px)

        &--active {
            display block
        }

        &__header {
            background #d0cfd0
            background linear-gradient(to top, #c8c5c8, #eae7ea)
            height 21px
            border-bottom 1px solid #b4b4b4
            width 100%
            overflow auto
            clear both
            padding 0
            display flex
            align-items center
            flex-flow row nowrap
            justify-content space-between

            &:before {
                content ''
                width 70.5px
                display inline-block
            }

            &-browser,
            &-table {
                border-bottom none
            }
        }

        &__content {
            height calc(100% - 21px)
            overflow auto

            &-calendar {
                /deep/ .table-card {
                    box-shadow none !important
                    border-top 1px solid #c8c5c8
                    height calc(100% - 45px) !important
                }

                /deep/ .table-card__content {
                    box-shadow none !important
                }
            }
        }

        &__buttons {
            font-size 0
            margin-right 9px
            display flex
            align-items center
            flex-flow row nowrap
            justify-content space-between
        }

        &__button {
            height 12px
            width @height
            border-radius 50%
            background #b3b2b3
            display inline-block
            border solid 1px rgba(179, 178, 179, 0.15)
            margin-right 8.5px
        }

        &__title {
            font-family helvetica, arial, sans-serif;
            line-height 21px
            font-size 13px
            font-weight light
            color rgb(34,32,34)
        }
    }

    .system-tabs {
        width 100%
        height 100%
        display flex
        flex-direction column
        justify-content space-between

        /deep/ .tabs__bar {
            order 2
        }

        /deep/ .tabs__items {
            order 1
            flex 1 1
        }

        /deep/ .tabs__content {
            border-radius 5px
            overflow hidden
            transition none
            box-shadow 0 2px 5px rgba(0, 0, 0, 0.2)
        }
    }
</style>